module.exports = __webpack_public_path__ + "media/images/country_flags/pk-88d313554999e21ab34419d88d03faca.png";